import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
// import { getCurrentEnv } from "@sfly/uig-current-environment-util";


class ToolbarTemplateCostco extends Component {
    constructor(props) {
        super(props);
        this.state = {
            queryString: queryString.parse(window.location.search)
        }
    }
    handleBack = () => {
        this.props.history.goBack();
    }
    render() {
        return (
            <React.Fragment>
                <h1 className={`zuul-toolbar zuul-toolbar-costco costco-header ${this.state.queryString.source ? 'zuul-source-override' : ''}`} aria-label='Header'><span style={{ display: 'none' }}>Header</span>
                    <div aria-label='shutterfly logo' className={'logo logo4'} onClick={() => { }}></div>
                    <div aria-label='costco logo' className={'logo logo3'} onClick={() => { }}></div>
                </h1>
                {this.props.centralConfig.show_downtime_banner && <div className={'downtime-banner'}><img src='//cdn-image.staticsfly.com/i/home/error_md.png' alt='error_sybl' /><p>{this.props.centralConfig.show_downtime_banner_error}</p></div>}
                {this.props.children}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        centralConfig: state.app.centralConfig,
        translator: state.app.translator,
        iconUrl: state.icon.informationSelected
    };
};

export default connect(mapStateToProps)(ToolbarTemplateCostco);
